/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Group_Delete_ConfirmInputs */

const vi_shop_group_delete_confirm = /** @type {(inputs: Shop_Group_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá nhóm "${i?.name}"? Trang sản phẩm của nhóm trên website và Mini App sẽ mất, không hoàn tác được.`)
};

/**

* @param {Shop_Group_Delete_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_delete_confirm = /** @type {((inputs: Shop_Group_Delete_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Delete_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_delete_confirm(inputs)
});